import { ResponsiveDialogProvider } from '@eliadmin/core/src/components/ui/responsive-dialog';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useJobportalOffersStore } from '@eliadmin/core/src/stores/jobportal-offers-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { JobOffersSortButton } from './filter/job-offers-sort-button';
import { JobOffersFilterButton } from './filter/job-offers-filter-button';

export const jobOffersSortOptions = [
  { label: 'Najstaršie', value: 'published_at:asc' },
  { label: 'Najnovšie', value: 'published_at:desc' },
];

export const JobportalOffersHeader = () => {
  const { t } = useTranslations();
  const { setFilter, applyFilter, filter } = useJobportalOffersStore();

  const handleFilterChange = (filter: {
    order: 'asc' | 'desc';
    orderBy: 'published_at' | 'salary' | 'distance';
  }) => {
    setFilter(filter);
    applyFilter(filter);
  };

  return (
    <div className="mb-8 flex flex-col gap-6 px-4 md:px-0">
      <h1 className="w-full text-3xl font-bold text-foreground md:block">{t('text788')}</h1>
      <div className="hidden items-center justify-start gap-8 md:flex">
        {jobOffersSortOptions.map((option, index) => (
          <button
            type="button"
            aria-pressed={
              filter.order === option.value.split(':')[1] &&
              filter.orderBy === option.value.split(':')[0]
            }
            key={index}
            className={cn(
              'cursor-pointer text-base font-normal text-primary',
              filter.order === option.value.split(':')[1] &&
                filter.orderBy === option.value.split(':')[0]
                ? 'font-semibold'
                : '',
            )}
            onClick={() =>
              handleFilterChange({
                order: option.value.split(':')[1] as 'asc' | 'desc',
                orderBy: option.value.split(':')[0] as 'published_at' | 'salary' | 'distance',
              })
            }
          >
            {option.label.startsWith('text') ? t(option.label) : option.label}
          </button>
        ))}
      </div>
      <div className="flex flex-col md:hidden">
        <ResponsiveDialogProvider>
          <div className="flex gap-4">
            <JobOffersSortButton />
            <JobOffersFilterButton />
          </div>
        </ResponsiveDialogProvider>
      </div>
    </div>
  );
};
